import React, { useEffect } from "react"
import { requestRegions } from "../state/modules/region"
import { connect } from "react-redux"

const RegionLoader = ({ hasRequestedRegions, requestAvailableRegions }) => {
  // request available regions if that information is not already present
  useEffect(() => {
    if (!hasRequestedRegions) {
      requestAvailableRegions()
    }
  }, [hasRequestedRegions, requestAvailableRegions])

  return <></>
}

const mapStateToProps = state => {
  return {
    hasRequestedRegions: state.region.hasRequestedRegions,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestAvailableRegions: () => dispatch(requestRegions()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegionLoader)
